export const EMPTY_VERIFICATION_CODE_ARRAY = ['', '', '', '', '', ''];
//# sourceMappingURL=auth.js.map